import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";
var today = new Date();
today.setHours(today.getHours() - 6);
// today.setDate(today.getDate() - 1);
const otherSlice = createSlice({
  name: "other",
  initialState: {
    sidebar_width: true,
    current_tab: 0,
    date: {
      start: moment(today).format("YYYY-MM-DD HH:mm:ss"),
      end: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    },
  },
  reducers: {
    fullSliderwidth(state) {
      state.sidebar_width = !state.sidebar_width;
    },
    setCurrentTab(state, action) {
      state.current_tab = action.payload;
    },
    setDaterange(state, action) {
      state.date = action.payload;
    },
  },
});

export const { fullSliderwidth, setCurrentTab, setDaterange } =
  otherSlice.actions;
export default otherSlice.reducer;
